import { useEffect, useState } from 'react';
import './Livros.css';
import Header from '../../componentes/js/Header';
import Footer from '../../componentes/js/Footer';
import LivrosGrid from '../../componentes/js/LivrosGrid';

const Livros = () => {
    const [livros, setLivros] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
        setIsMobile(true);
        }
        
        const fetchLivros = async () => {
            try {
                const response = await fetch('https://server-colegiolider.onrender.com/api/livros/all');
                if (!response.ok) {
                    throw new Error('Erro ao buscar dados: ' + response.statusText);
                }
                const data = await response.json();
                setLivros(data);
            } catch (error) {
                console.error('Erro:', error);
            }
        };

        fetchLivros();
    }, []);

    return (
        <div style={{backgroundImage: 'url(assets/images/fundo/fundo2.png)', backgroundSize: isMobile ? '60%' : '25%', backgroundPosition: 'center', backgroundRepeat: 'repeat', marginBottom: '-16vh'}}>
            <Header />
            <main>
            <div className='conteudo'>
                <h2>Todos os Livros</h2>
                <LivrosGrid livros={livros} />
            </div>
            </main>
            <Footer />
        </div>
    );
};

export default Livros;